import React, { useEffect, useRef, useState } from 'react'
import { useOutletContext, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { RiPagesLine } from 'react-icons/ri'
import { IoFilter } from "react-icons/io5"
import { IoAddCircleOutline, IoRemoveCircle } from 'react-icons/io5'
import moment from 'moment'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'

import FilterForm from '../FilterForm'
import RouterFormModal from './components/RouterFormModal'

const NetworkRouter = () => {
  const { profile, role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [data, setData] = useState([])

  const [formOpen, setFormOpen] = useState({
    "isOpen": false,
    "device": null,
    "mode": null
  })

  const [filterFormOpen, setFilterFormOpen] = useState(false)

  const tableRef = useRef()

  const filterRef = useRef({
    "project": ""
  })

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/network_router/router_list_by_orginization`,
      params: {
        "project": filterRef.current.project,
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"]
      },
      returnType: "json"
    })

    setData({
      "data": body["data"].map((i) => ({
        "device_id": i["device_id"],
        "project": i["project"],
        "name": i["device_name"]
      })),
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const reloadData = async () => {
    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  const onFilter = async (values) => {
    filterRef.current.project = values["project"]

    setFilterFormOpen(false)

    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  const toggleForm = (row, mode) => {
    if (mode){
      setFormOpen({
        "isOpen": true,
        "device": row,
        "mode": mode
      })
    }
    else {
      setFormOpen({
        "isOpen": false,
        "device": null,
        "mode": null
      })
    }
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={data["data"]} count={data["count"]} loadData={reloadData} ref={tableRef}
              columns={{
                "project": { "label": t("general_project"), "sorting": false, "nowrap": true },
                "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "device_id": { "label": t("roter_mac"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                {icon: <IoFilter size={20}/>, text: t("general_filter"), onClick: function() { setFilterFormOpen(true) }},
                {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { toggleForm(null, "Create") }}
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <RouterFormModal isOpen={formOpen["isOpen"]} device={formOpen["device"]} mode={formOpen["mode"]} onClose={toggleForm} loadData={() => reloadData()}/>

    <FilterForm filterRef={filterRef} isOpen={filterFormOpen} toggleForm={() => setFilterFormOpen(false)} onFilter={onFilter}/>
  </>)
}

export default NetworkRouter
